module.exports = __webpack_public_path__ + "media/images/bg/footer-bg-cup-84edbd1247d7b076bc9d5be2a338b196.jpg";